import LegalLayout from "@/components/LegalLayout";
import { Mail, MapPin, MessageCircle, Headset, Wrench } from "lucide-react";

export default function ContactUs() {
    const blocks = [
        {
            icon: Headset,
            title: "Design Related Support",
            email: "ganesh@filescad.com",
            desc: "For inquiries about our products, pricing, CAD software support and custom designs, please reach out to our dedicated design team.",
            testId: "contact-design",
        },
        {
            icon: Wrench,
            title: "Technical Support",
            email: "manoj@filescad.com",
            desc: "Need assistance with a purchase, technical issues, or payment-related support? Our technical support team is here to help you.",
            testId: "contact-tech",
        },
    ];

    return (
        <LegalLayout testId="contact-us-page" title="Contact Us">
            <p className="text-lg text-slate-700">
                We&rsquo;d love to hear from you. Pick the channel that matches your question — we usually respond within 24 hours.
            </p>

            <div className="not-prose grid grid-cols-1 md:grid-cols-2 gap-5 mt-8">
                {blocks.map((b) => (
                    <div
                        key={b.title}
                        data-testid={b.testId}
                        className="rounded-2xl border border-slate-200 p-6 bg-white"
                    >
                        <div className="w-11 h-11 rounded-xl bg-slate-950 grid place-items-center mb-4">
                            <b.icon className="w-5 h-5 text-white" />
                        </div>
                        <h4 className="font-display font-bold text-lg text-slate-950">{b.title}</h4>
                        <p className="mt-2 text-slate-600 text-sm leading-relaxed">{b.desc}</p>
                        <a
                            href={`mailto:${b.email}`}
                            className="mt-4 inline-flex items-center gap-2 text-blue-600 hover:underline font-semibold text-sm"
                        >
                            <Mail className="w-4 h-4" /> {b.email}
                        </a>
                    </div>
                ))}
            </div>

            <h3 className="font-display font-bold text-2xl text-slate-950 mt-12">Mailing Address</h3>
            <div className="not-prose rounded-2xl border border-slate-200 p-6 bg-white">
                <div className="flex items-start gap-3">
                    <MapPin className="w-5 h-5 text-blue-600 mt-1 shrink-0" />
                    <div>
                        <p className="text-slate-700">Arna-Jarna, Mokalawas, Jodhpur, Rajasthan (342001), India</p>
                        <a
                            href="mailto:support@filescad.com"
                            data-testid="contact-mail-email"
                            className="mt-3 inline-flex items-center gap-2 text-blue-600 hover:underline font-semibold text-sm"
                        >
                            <Mail className="w-4 h-4" /> support@filescad.com
                        </a>
                    </div>
                </div>
            </div>

            <h3 className="font-display font-bold text-2xl text-slate-950 mt-12">WhatsApp</h3>
            <p className="flex items-center gap-3">
                <MessageCircle className="w-4 h-4 text-emerald-600" />
                <a
                    href="support@filescad.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="contact-whatsapp"
                    className="text-blue-600 hover:underline font-semibold"
                >
                    support@filescad.com
                </a>
            </p>
        </LegalLayout>
    );
}
